import {motion} from "framer-motion";
import SlotCounter from 'react-slot-counter';
import {AccessBtnComponent} from '../access-btn.component';
import {Parallax} from 'react-scroll-parallax';
import {useNavigate} from 'react-router';

const MainBackground: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div
            className="relative h-[100svh] w-full overflow-hidden bg-opacity-90 ">
            <video
                className="absolute top-0 left-0 w-full h-full object-cover opacity-15 invert"
                autoPlay
                muted
                loop={false}
                playsInline
            >
                <source src="/assets/bg-flower.mp4" type="video/mp4"/>
                {/* fallback для браузеров, не поддерживающих видео */}
                Your browser does not support the video tag.
            </video>

            <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50"/>

            <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">
                <div className="min-h-1/2">

                    <motion.h1
                        className="text-6xl lg:text-9xl font-bold text-white font-boldonse"
                        initial={{opacity: 0, y: -50}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.8}}
                    >
                        {/*<div className="text-3xl lg:text-8xl font-bold text-white font-boldonse">*/}
                        <SlotCounter
                            dummyCharacters={'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(char => (
                                <span className="">{char}</span>))}
                            duration={2}
                            value={[
                                <span className="bg-gray-300 p-5"><span
                                    className="bg-pink-700 text-transparent bg-clip-text">S</span></span>,
                                <span className="bg-pink-700 text-transparent bg-clip-text">l</span>,
                                <span className="bg-pink-700 text-transparent bg-clip-text">o</span>,
                                <span className="bg-pink-700 text-transparent bg-clip-text">t</span>,
                                <span>{' '}</span>,
                                <span className="bg-gray-300 p-5"><span
                                    className="bg-pink-700 text-transparent bg-clip-text">A</span></span>,
                                <span className="bg-pink-700 text-transparent bg-clip-text">r</span>,
                                <span className="bg-pink-700 text-transparent bg-clip-text">t</span>,
                                <span>{' '}</span>,


                            ]}/><br/>
                        <SlotCounter
                            dummyCharacters={'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(char => (
                                <span className="">{char}</span>))}
                            duration={2}
                            value={[
                                <span className="bg-clip-text">D</span>,
                                <span className="">e</span>,
                                <span className="">v</span>,
                                <span className="">e</span>,
                                <span className="">l</span>,
                                <span className="">o</span>,
                                <span className="">p</span>,
                                <span className="">m</span>,
                                <span className="">e</span>,
                                <span className="">n</span>,
                                <span className="">t</span>,
                            ]}/>
                        {/*</div>*/}
                    </motion.h1>

                    <Parallax speed={-10}>
                        <motion.p
                            className="mt-12 lg:text-5xl text-2xl text-gray-200 font-inter text-center"
                            initial={{opacity: 0, y: 20}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.8, delay: 0.3}}
                        >
                            100% Original Art.<br/>
                            Endless theming. Quick reskins.<br/>
                        </motion.p>
                    </Parallax>
                </div>

                <motion.div className="w-full h-1/4 flex flex-col md:flex-row justify-center z-30">
                    <div className="lg:w-2/3 w-full flex md:flex-row flex-col gap-12 lg:ml-28 mt-48">
                        <div>
                            <AccessBtnComponent text="View Art"
                                                onClick={() => navigate('/slots')}
                                                className="px-24 md:py-8 py-4 border-2 border-pink-700 rounded-xl text-white relative mt-6 text-lg bg-pink-600 font-semibold"/>
                        </div>

                    </div>
                    <div className="lg:w-1/3 w-full hidden md:block relative">
                        <div className="h-full relative">

                            <img
                                alt=""
                                loading="lazy"
                                className="absolut top-0 left-0 min-h-96 saturate-0 w-auto hover:scale-105 hover:rotate-3  hover:text-white transition focus:outline-none"
                                src="https://storage.googleapis.com/lesia-k/Pictures/CatFish.png"/>
                        </div>
                    </div>

                </motion.div>
            </div>

        </div>
    );
}

export default MainBackground;
